<template>
  <b-card class="card-congratulation-medal" v-if="data.data">
    <h5>پر بازدیدترین جلسه 🎉</h5>
    <h3 class="my-2">درس {{ data.data.name }}</h3>
    <h6>
      تعداد بازدید :
      <b-badge variant="warning" class="px-1 py-50">
        {{ data.count_seen }}
      </b-badge>
    </h6>
    <b-img
      class="d-none d-sm-inline congratulation-medal"
      :src="require('@/assets/images/illustration/badge.svg')"
      alt="Medal Pic"
    />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardText,
  BLink,
  BButton,
  BImg,
  BSkeleton,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCard,
    BSkeleton,
    BCardText,
    BLink,
    BImg,
    BButton,
    BBadge,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
